import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errorMessage } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { MailCheck } from "lucide-react";
import { AuthShell, inputCls, labelCls } from "../components/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (e2) {
      setErr(errorMessage(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Forgot password" subtitle="Enter your account email and we'll send you a reset link.">
      {sent ? (
        <div className="flex items-start gap-3 rounded-md border border-emerald-500/25 bg-emerald-500/[0.06] p-4" data-testid="forgot-password-sent">
          <MailCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-300" />
          <div className="text-sm text-emerald-100/90">
            If an account exists for <b>{email}</b>, a reset link is on its way. It's valid for 1 hour — check your spam folder too.
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
          <div>
            <Label htmlFor="email" className={labelCls}>Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className={inputCls} data-testid="forgot-password-email-input" />
          </div>
          {err && <div className="rounded-md border border-rose-500/20 bg-rose-500/10 px-3 py-2 text-sm text-rose-300" data-testid="forgot-password-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full bg-emerald-600 text-white hover:bg-emerald-500 disabled:opacity-60" data-testid="forgot-password-submit-btn">
            {busy ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
      <div className="mt-7 text-center text-sm text-slate-400">
        Remembered it?{" "}
        <Link to="/login" className="text-emerald-300 hover:text-emerald-200" data-testid="forgot-back-to-login-link">Back to sign in</Link>
      </div>
    </AuthShell>
  );
}
